document.addEventListener('alpine:init', () => {
  window.Alpine.store('downloadModal',{
    showModal: false,
    url: '',
    isDownload: false
  });

  window.Alpine.data('downloadModal', () => ({
    init () {
    },

    overrideClick(ev) {
      const {showModal} = window.Alpine.store('downloadModal');

      if (this.isConsentAccepted() || showModal) {
        return;
      }

      ev.preventDefault();

      const url = ev.target.getAttribute('href') ?? '';
      const isDownload = ev.target.hasAttribute('download');

      window.Alpine.store('downloadModal', {
        showModal: true,
        url,
        isDownload
      });
    },

    openDownloadLink() {
      this.accept();

      const {url} = window.Alpine.store('downloadModal');

      if (! url) {
        this.closeModal();
      }

      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.download = "";
      document.body.appendChild(tempLink);
      tempLink.click();
      tempLink.remove();

      this.closeModal();
    },

    closeModal() {
      window.Alpine.store('downloadModal', {
        showModal: false
      });
    },

    accept() {
      if (! this.isLocalStorageAvailable()) {
        return;
      }

      window.localStorage.setItem('aps-download-consent', 'true');
    },

    isConsentAccepted() {
      if (! this.isLocalStorageAvailable()) {
        return false;
      }

      return 'true' === window.localStorage.getItem('aps-download-consent');
    },

    isLocalStorageAvailable() {
      try {
        localStorage.setItem('aps-localstorage-test', 'test');
        localStorage.removeItem('aps-localstorage-test');

        return true;
      } catch(e) {
        return false;
      }
    }
  }));
});
